export const memberStatsKeys = {
    all: ['memberStats'] as const,
    stats: (centerId: string) =>
        [...memberStatsKeys.all, 'stats', centerId] as const,
};
